<template>
  <div
    id="email-modal"
    class="modal modal-fixed-footer medium"
  >
    <div class="modal-content">
      <div class="col s12">
        <h5>Send Email</h5>
      </div>
      <div class="col s12">
        <rich-text @content-update="setContent" />
      </div>
    </div>

    <div class="modal-footer">
      <a
        href="#!"
        class="btn-flat green"
        @click="submit(entity)"
      >Gem</a>
      <a
        href="#!"
        class="waves-effect waves-green btn-flat red"
        @click="close"
      >Close</a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      activeFilters: {
        type: Object,
        default () {
          return {}
        },
      },
    },
    data () {
      return {
        content: '',
      }
    },

    mounted: function () {
    },
    methods: {
      submit: function () {},

      setContent: function (content) {
        this.content = content
      },
    },
  }
</script>
